<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 43.01 43.77"
    style="
      fill: none;
      stroke: #000;
      stroke-linecap: round;
      stroke-linejoin: round;
    "
  >
    <path
      d="M6.87,38.85a89,89,0,0,0,9.82,4.29c.7.28,1.06.09,1.74-.41,1.71-1.25,1.5-2.54,3.88-5.1,1.65-1.77,3.51-4.47,5.21-6.31.59-.65,1-.09,3-.29A26.09,26.09,0,0,0,38,29c1.47-.63,2.19-2.13,2.38-4A83.55,83.55,0,0,1,42,14.38c1-4.26.64-8.45-2.62-11.8a4.5,4.5,0,0,0-3.46-1.43c-4.11,0-7.49-.42-11.59-.34C22.51.84,20,.55,18.24.51a28.83,28.83,0,0,0-7.69,1.14C8,2.27,5.69,3.68,3,4.06,1.2,4.32.77,5.58,1.28,7.68s1,4.06,1.34,6.11c.72,4.52-.41,8.8-1.72,13C.11,29.39.46,31,2.26,31.22c1.31.15,3.17.54,4.52,0"
    />
    <path
      d="M13.32,21.88c-1.51-.14-1.11-3.58-1-5.15s-.86-3.88-2-4.48c-1.3-.68-1.05,3.39-1.16,4.23-.55,4-1,4.22-2.36,9-.67,2.26-.26,5.14.35,7.5.49,1.88,0,3.8-.16,5.69-.13,0,.12,0,0,0"
    />
    <path
      d="M23.21,9.45c.13-4.9-2.36-3.82-3.95-.21-1.16,2.63-2.26,5.67-3.72,8.51a23.72,23.72,0,0,1-2.22,4.13"
    />
    <path
      d="M27.51,10.24c.34-1.28.59-4.28-.39-5-.76-.59-2.13.7-2.58,1.56A18.09,18.09,0,0,0,23.06,9.9C21.65,14,20,17.26,18.45,21.28"
    />
    <path
      d="M29,16.78c3.3-4.74,3.95,0,1.81,4.5-1,2-1.44,5.11-2.1,7.18a20.62,20.62,0,0,1-1.55,3.36"
    />
    <path
      d="M26.26,23.79c1.08-2,1.38-4.34,2.4-6.39a20.1,20.1,0,0,0,2.08-5.93c.41-3.2-2.52-2.51-3.23-1.23-2.15,3.91-3.1,8.28-4.58,12.72"
    />
  </svg>
</template>